<mat-chip class="badge" [class]="'badge--' + type()" disableRipple>
  <mat-icon matChipAvatar>{{ icon() }}</mat-icon>
  {{ translationKey() | transloco }}
</mat-chip>
